// @flow

import * as React from 'react';
import Paper from '@material-ui/core/Paper';
import { useTheme } from '../theme';

export const Alert = ({ children }: {| children: React.Node |}): React.Node => {
  const { colors, text } = useTheme();

  return (
    <Paper
      css={{
        ...text.body2,
        background: colors.green[100],
        border: `1px solid ${colors.green[200]}`,
        boxShadow: 'none',
        padding: '16px',
        color: colors.green[900],
      }}
    >
      {children}
    </Paper>
  );
};
